import styled, { css } from 'styled-components';
import { borderRadius } from '@bufferapp/ui/style/borders';
import { grayLight, gray, grayShadow } from '@bufferapp/ui/style/colors';
import { PostPreviewWrapper } from '../../../PostPreview/styles';
import { isDraft } from '../../../../utils/isDraft';

const getBackgroundColor = ({ type, needsApproval, isBlueprint }) => {
  if (isDraft(type) && isBlueprint) return '#EEF6E0';
  if (isDraft(type) && needsApproval) return '#FCEFEA';
  if (isDraft(type)) return '#EAEDFF';
  return 'inherit';
};

export const PostWrapper = styled.div`
  border-radius: ${borderRadius};
  height: ${(props) => (props.small ? '30px' : '40px')};
  background-color: ${(props) => getBackgroundColor(props)};
  padding: ${(props) => (props.small ? '0 0 0 8px' : '8px')};

  &:after {
    ${(props) =>
      props.campaignColor &&
      css`
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${props.campaignColor};
        width: 4px;
        height: 100%;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      `}
  }
`;

export const PostPreviewHoverWrapper = styled.div`
  border-radius: ${borderRadius};
  border: 1px solid ${grayLight};
  box-shadow: ${grayShadow};
  box-sizing: border-box;
  margin-bottom: 8px;
  transition: all 0.3s ease-in-out;
  position: relative;

  &:hover {
    ${({ $canEdit }) =>
      $canEdit &&
      css`
        cursor: pointer;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 8px 24px;
        border: 1px solid ${gray};
        z-index: 1;
      `};

    ${PostPreviewWrapper} {
      box-shadow: rgb(0 0 0 / 22%) 0px 19px 43px;
      animation: 0.2s linear 0.4s forwards delayedShow;

      @keyframes delayedShow {
        from {
          visibility: hidden;
          opacity: 0;
        }
        to {
          visibility: visible;
          opacity: 1;
        }
      }

      button svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  // This is used to prevent the preview from disappearing when moving in the gap between the two
  &::before {
    content: '';
    height: 8px;
    width: 100%;
    position: absolute;
    bottom: -8px;
    left: 0px;
  }
`;
